import { render } from "./GameBar.vue?vue&type=template&id=122a7f3e&scoped=true&ts=true"
import script from "./GameBar.vue?vue&type=script&lang=ts"
export * from "./GameBar.vue?vue&type=script&lang=ts"

import "./GameBar.vue?vue&type=style&index=0&id=122a7f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122a7f3e"]])

export default __exports__